import React from 'react';
import styled from 'styled-components';
import { Helmet } from 'react-helmet';
import {
  Stack,
  Typography,
  TextField,
  textFieldClassNames,
  StandardButton,
} from '@moonsifttech/design-system';

import R from 'src/routes';
import TopMenu from 'src/mvp22/menu-components/TopMenu';
import { CreatorDashboardProps } from './CreatorDashboard.types';

const UnstyledCreatorDashboard: React.FC<CreatorDashboardProps> = ({
  className,
  style,
  copied,
  onCopy,
  onBack,
}) => {
  return (
    <div className={className} style={style}>
      <Helmet>
        <title>Creator dashboard - Moonsift</title>
      </Helmet>
      <TopMenu
        className="CreatorDashboard-topMenu"
        hug="edge"
        selected={R.HOME}
      />
      <Stack className="CreatorDashboard-container">
        <Typography
          className="CreatorDashboard-heading"
          variant="editorial.sb34"
          align="center"
        >
          Your Creator Account is being reviewed
        </Typography>
        <Typography
          className="CreatorDashboard-paragraph"
          variant="primary.l16"
          align="center"
        >
          We manually review each account before it's connected with our brand
          affiliate network.
        </Typography>
        <Typography
          className="CreatorDashboard-paragraph"
          variant="primary.l16"
          align="center"
        >
          We will let you know as soon as your account has been activated.
        </Typography>
        <Typography
          className="CreatorDashboard-paragraph"
          variant="primary.l16"
          align="center"
        >
          You can start creating collections straight away, you just wont be
          able to see how much they are earning yet.
        </Typography>
        <Stack direction="row" justifyContent="center">
          <hr />
        </Stack>
        <Typography
          className="CreatorDashboard-heading"
          variant="editorial.sb34"
          align="center"
        >
          Invite other creators
        </Typography>
        <Typography
          className="CreatorDashboard-subheading"
          variant="editorial.r22"
          align="center"
        >
          Share your unique signup link
        </Typography>
        <Typography
          className="CreatorDashboard-paragraph"
          variant="primary.l16"
          align="center"
        >
          Creator accounts are currently{' '}
          <Typography variant="primary.r16">invite only</Typography>. Invite
          other creators now before we open to the public and wait times
          increase.
        </Typography>
        <Stack direction="row" justifyContent="center">
          <Stack className="CreatorDashboard-form" spacing={4}>
            <form className="CreatorDashboard-form" onSubmit={onCopy}>
              <TextField
                name="url"
                defaultValue={`${window.location.origin}${R.CREATOR_LANDING}`}
              />
              <StandardButton
                type="submit"
                variant="primary-black"
                disabled={copied}
              >
                {copied ? 'Copied' : 'Copy'}
              </StandardButton>
            </form>
            <Typography
              className="CreatorDashboard-infoCopy"
              variant="primary.r14"
              color="grey.3"
            >
              Copy and share this link
            </Typography>
            <Stack
              className="CreatorDashboard-buttonContainer"
              direction="row"
              justifyContent="center"
            >
              <StandardButton variant="primary-white" onClick={onBack}>
                Back to profile
              </StandardButton>
            </Stack>
          </Stack>
        </Stack>
      </Stack>
    </div>
  );
};

export const CreatorDashboard = styled(UnstyledCreatorDashboard)`
  min-height: 100vh;
  background: var(--grey-7);

  .CreatorDashboard-topMenu {
    height: 56px;
    margin-bottom: 8px;
    overflow: hidden;
    margin-bottom: calc(16px + 28px);
  }

  .CreatorDashboard-container {
    margin: 0 auto;
    padding: 0 24px;
    max-width: 448px;
  }

  .CreatorDashboard-heading {
    margin-bottom: 20px;
  }

  .CreatorDashboard-subheading {
    margin-top: -8px;
    margin-bottom: 20px;
  }

  .CreatorDashboard-paragraph {
    margin-bottom: 20px;
  }

  hr {
    width: 100%;
    max-width: 328px;
    margin: 20px 0 40px;
    border-top: 1px solid var(--grey-4);
    border-bottom: none;
  }

  .CreatorDashboard-form {
    display: flex;
    margin-bottom: 8px;

    .${textFieldClassNames.root} {
      margin-right: 4px;
    }
  }

  .CreatorDashboard-infoCopy {
    margin-bottom: 40px;
  }

  .CreatorDashboard-buttonContainer {
    margin-bottom: 100px;
  }

  ${({ theme }) => theme.fns.getMediaQuery({ minWidth: 'md' })} {
    .CreatorDashboard-topMenu {
      margin-bottom: calc(16px + 76px);
    }
  }
`;
